<template>
  <v-data-table
    :headers="[
      { text: 'Level', value: 'level' },
      { text: 'Type', value: 'type' },
      { text: 'Message', value: 'message' },
      { text: 'Time', value: 'createdAt' },
    ]"
    :items="logs"
    :options.sync="options"
    :server-items-length="totalLogs"
    :footer-props="{
      'items-per-page-options': [10, 20, 30, 40, 50],
      'show-first-last-page': true,
    }"
    :loading="loading"
    disable-sort
    show-expand
  >
    <template #top>
      <v-toolbar flat color="white">
        <v-toolbar-title>Logs</v-toolbar-title>
        <v-divider class="mx-4" inset vertical />
        <v-spacer></v-spacer>
        <button
          class="default-btn red"
          @click="$emit('removeAll')"
        >Clear all logs</button>
      </v-toolbar>

      <v-divider class="section-divider condensed" />
    </template>

    <template #item.message="{ value }">
      {{ value.length > 140 ? value.slice(0, 137) + '...' : value }}
    </template>

    <template #item.createdAt="{ value }">
      {{ value | datetime }}
    </template>

    <template #expanded-item="{ headers, item }">
      <td :colspan="headers.length">
        <h5>Full Message</h5>
        <div>{{ item.message }}</div>

        <h5 v-if="item.data">Additional Log Data</h5>
        <dl v-if="item.data" class="grid-wrapper">
          <template v-for="(value, key) in item.data">
            <dt :key="'key-' + key">{{ key }}</dt>
            <dd :key="'value-' + key">{{ value }}</dd>
          </template>
        </dl>
      </td>
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: 'LogsTable',
  props: {
    logs: Array,
    totalLogs: Number,
    loading: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    options: {
      itemsPerPage: 10,
      page: 1,
    },
  }),

  watch: {
    options () {
      this.$emit('page:changed', this.options.page, this.options.itemsPerPage)
    },
  },

  methods: {},
}
</script>

<style lang="scss" scoped>
::v-deep {
  td, th {
    padding: 4px 8px;
  }

  .v-data-table__expanded__content td {
    padding: 10px 20px 20px !important;

    h5 {
      margin-top: 10px;
    }
  }
}

.grid-wrapper {
  grid-template-columns: auto auto;
  justify-content: flex-start;
  align-items: center;
  grid-gap: 5px 10px;
}

dt {
  font-weight: bold;
}
</style>
